// If the url begins with staging, we use the staging apis
window.GLOBAL_ENV = GLOBAL_ENV
if (window.location.host === 'staging.thinkpickle.com.au') {
  window.GLOBAL_ENV.API_TYPE = 'staging'
}



// WEBPACK FOOTER //
// ./src/app/setGlobalEnv.js